import React, { useCallback, memo } from 'react';
import Modal from './Modal';
import Button from './button/Button';

import styles from './styles/ConfirmationDialog.module.css';

const ConfirmationDialog = ({ 
    isOpen, 
    onClose, 
    onConfirm, 
    title = "Confirm Action", 
    message,
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmVariant = "primary",
    dangerous = false
}) => {
    const handleConfirm = useCallback(() => {
        onConfirm();
        onClose();
    }, [onConfirm, onClose]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} title={title}>
            <div className={styles.content}>
                <p className={styles.message}>{message}</p>
                <div className={styles.actions}>
                    <Button onClick={onClose} variant="primary" size="medium">
                        {cancelText}
                    </Button>
                    <Button
                        onClick={handleConfirm}
                        variant={dangerous ? "danger" : confirmVariant}
                        size="medium"
                    >
                        {confirmText}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default memo(ConfirmationDialog);
